import { render } from "./SimpleHeaderDesktop.vue?vue&type=template&id=4f7e5fc9&scoped=true"
import script from "./SimpleHeaderDesktop.vue?vue&type=script&lang=js"
export * from "./SimpleHeaderDesktop.vue?vue&type=script&lang=js"

import "./SimpleHeaderDesktop.vue?vue&type=style&index=0&id=4f7e5fc9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7e5fc9"]])

export default __exports__